import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { UserFull } from '../models/user-master/user-lite';

import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class UsersProxyService {
  private readonly baseUrl = environment.proxyUrls.userMasterApi + '/api/v1/user';
  private readonly httpClient = inject(HttpClient);

  getAllUsers(): Observable<ApiResponse<UserFull[]>> {
    return this.httpClient.get<ApiResponse<UserFull[]>>(`${this.baseUrl}/all`);
  }
}
